import { MessageBackend as createMessageBackendExportIssuesFlyoutInMeatballMenu, MessageFrontend as createMessageFrontendExportIssuesFlyoutInMeatballMenu } from '@post-office/message-template--export-issues-flyout-in-meatball-menu/placements/in-app-v2/jira-nin-meatball-menu-button'

import { productionRuntime } from '@post-office/placement-common-v2/placement-runtime';
import { PlacementBackend, PlacementFrontend } from '@post-office/placements--jira-empanada/jira-nin-meatball-menu-button';


import { withI18n } from './i18n';

export const placementBackendFactory = PlacementBackend.createPlacementBackend({
				messageTemplates: [createMessageBackendExportIssuesFlyoutInMeatballMenu({messageTemplateId: 'export-issues-flyout-in-meatball-menu'})],
			})

export const RawPlacement = PlacementFrontend.createPlacementFrontendComponent({
				messageTemplates: [createMessageFrontendExportIssuesFlyoutInMeatballMenu({messageTemplateId: 'export-issues-flyout-in-meatball-menu'})],
			});

export const Placement = withI18n(RawPlacement)

export const SSRPlacement = RawPlacement

export const middleware = placementBackendFactory(productionRuntime);
